import { connect } from '@lumapps/redux/react';
import {
    getLanguages,
    currentLanguageSelector as defaultLanguageSelector,
    isLanguageSelectButtonEnabled,
    inputLanguageSelector,
} from '@lumapps/translations/ducks/selectors';

import { LanguageSelectButton } from './LanguageSelectButton';

const mapStateToProps = (state: BaseStore, props: any) => {
    const { useCustomerLanguages, defaultLanguage, isVisible = false, languages = [] } = props;

    return {
        languages: getLanguages(state, useCustomerLanguages, languages),
        defaultLanguage: defaultLanguage || defaultLanguageSelector(state),
        isVisible: isLanguageSelectButtonEnabled(state) || isVisible,
        inputLanguage: inputLanguageSelector(state),
    };
};

const ConnectedLanguageSelectButton = connect(mapStateToProps)(LanguageSelectButton);

export { ConnectedLanguageSelectButton as LanguageSelectButton };
